/*
  Keeps the Add to Cart button in sync with the option picked in the custom
  subscription widget (1 bottle / 3 bottles / Subscribe & Save).

  The widget's inline script never runs inside the Quick View modal (its HTML
  is injected via innerHTML, so <script> tags are skipped), and the compiled
  widget only toggles the button when a matching variant radio exists. Result:
  a sold-out option could still show "Add to Cart", or "Sold Out" stuck after
  switching to an in-stock option. This resolves the chosen variant per form,
  writes it to the form's id input, and sets the button's disabled state from
  that variant's availability.
*/
(function () {
  function parse(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function planVariantId(data, planId) {
    var plans = data.plans || [];
    for (var i = 0; i < plans.length; i++) {
      if (String(plans[i].id) === String(planId) && plans[i].variantId) return plans[i].variantId;
    }
    return data.autoship1VariantId || data.autoshipVariantId || null;
  }

  function syncForm(dataEl) {
    var data = parse(dataEl);
    var form = dataEl.closest('form');
    if (!data || !form) return;

    var root = form.closest('quick-view, product-section') || form.parentNode;
    var variants = parse(root.querySelector('#variantJson'));
    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[name="add"]');
    if (!Array.isArray(variants) || !idInput || !button) return;

    var id = null;
    var picked = form.querySelector('input[name="selling_plan"]:checked');
    if (picked && picked.dataset.type === 'onetime') {
      id = picked.id === 'appstle_selling_plan_label_20' ? data.variantId2 : data.variantId1;
    } else if (picked && picked.dataset.type === 'subscription') {
      var select = form.querySelector('#appstle_selling_plan0');
      id = planVariantId(data, select ? select.value : picked.value);
    }

    if (id && String(idInput.value) !== String(id)) idInput.value = id;

    var current = String(idInput.value);
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === current) { variant = variants[i]; break; }
    }
    if (!variant) return;

    if (variant.available) button.removeAttribute('disabled');
    else button.setAttribute('disabled', 'disabled');
  }

  function syncAll() {
    document.querySelectorAll('script[id^="csw-data-"]').forEach(syncForm);
  }

  // Run after the theme's own handlers (which may flip the button themselves).
  function schedule() {
    setTimeout(syncAll, 0);
    setTimeout(syncAll, 300);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form .appstle_sub_widget, product-form')) schedule();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.appstle_sub_widget')) schedule();
  });

  function watchQuickview() {
    var target = document.querySelector('[data-quickview-content]');
    if (target) new MutationObserver(schedule).observe(target, { childList: true });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchQuickview);
  else watchQuickview();
})();
